import { useOnline } from '../lib/use-online';

// Renders a small "Offline" pill in the top-right corner whenever the
// browser reports navigator.onLine === false. The pill exits as soon as
// the connection comes back; revalidation of cached queries is handled
// by TanStack Query's reconnect listener.
export function OfflineChip(): React.JSX.Element | null {
  const online = useOnline();
  if (online) return null;
  return (
    <output
      aria-live="polite"
      className="fixed right-3 top-3 z-50 inline-flex items-center gap-2 rounded-full bg-amber-100 px-3 py-1 text-xs font-medium text-amber-900 shadow-sm ring-1 ring-amber-200"
    >
      <span aria-hidden="true" className="inline-block h-2 w-2 rounded-full bg-amber-500" />
      Offline — showing cached data
    </output>
  );
}
